import * as _4 from 'lodash4';
import { Datasource, IDatasource } from 'utility-ng-kernel';

export class NoteReport {
  id: number;
  status: string;

  constructor(report: NoteReport) {
    _4.merge(this, {}, report);
  }
  static build(report: NoteReport): NoteReport {
    return new NoteReport(report);
  }
}

export interface INotesDatasource extends IDatasource<NoteReport> {}

angular.module('capability-ng-reports').factory('ngNotesDatasource', () => {
  return new Datasource<NoteReport>({
    builderType: NoteReport
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-reports/src/datasources/notes_datasource.ts